<template>
  <div class="page-content">
    <div class="page-header">
      <div class="searchbar fl">
        <el-form
          :inline="true"
          :model="filters"
          :size="btnSize"
          @keyup.enter.native="handleQuery()"
          @submit.native.prevent
        >
          <el-form-item label="合同签订时间">
            <el-date-picker
              style="width: 130px;"
              v-model="filters.signingTimeLeft"
              type="date"
              placeholder=""
            >
            </el-date-picker>
            -
            <el-date-picker
              style="width: 130px;"
              v-model="filters.signingTimeRight"
              type="date"
              placeholder=""
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同时间">
            <el-date-picker
              style="width: 130px;"
              v-model="filters.startTime"
              type="date"
              placeholder=""
            >
            </el-date-picker>
            -
            <el-date-picker
              style="width: 130px;"
              v-model="filters.endTime"
              type="date"
              placeholder=""
            >
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="合同类别">
            <el-select v-model="filters.type" style="width: 100px;" placeholder="">
              <el-option :value="0" label="租凭"></el-option>
              <el-option :value="1" label="托管"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button :size="btnSize" @click="handleQuery" type="primary" plain
              >查询</el-button
            >
          </el-form-item>
          <!-- <el-form-item>
            <el-button :size="btnSize" @click="handleAddOrUpdate" type="primary" plain>添加合同</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="content">
      <el-table
        ref="table"
        class="simple-table"
        :data="tableData"
        height="100%"
        highlight-current-row
        fit
        v-loading="dataListLoading"
      >
        <el-table-column
          prop="userName"
          label="签订时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="roleName"
          label="开始时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="realName"
          label="结束时间"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="业主公司"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="物业公司"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="合同状态"
          align="left"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="left"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-button
              class="table-btn"
              @click.native.prevent="handleDetail(scope.$index, scope.row)"
              type="text"
              :size="sizeMini"
              >查看详情</el-button
            >
            <!-- <el-button class="table-btn" v-if="filters.type === 0" @click.native.prevent="handleTermination(scope.$index, scope.row)" type="text" :size="sizeMini">终止</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-update
      ref="addOrUpdate"
      v-if="addOrUpdateVisible"
      @handleQuery="handleQuery"
    ></add-or-update>
    <detail-dialog
      ref="detailDialog"
      v-if="detailDialogVisible"
    ></detail-dialog>
  </div>
</template>

<script>
import addOrUpdate from "./addOrUpdate.vue";
import detailDialog from "./detailDialog.vue";
export default {
  name: "property",
  components: {
    addOrUpdate,
    detailDialog,
  },
  data() {
    return {
      filters: {
        type: 0,
        signingTimeLeft: "",
        signingTimeRight: "",
        startTime: "",
        endTime: "",
      },
      addOrUpdateVisible: false,
      dataListLoading: false,
      pageNum: [10, 20, 30],
      pageSizes: 1,
      pageSize: 1,
      totalSize: 1,
      btnSize: "small",
      sizeMini: "mini",
      tableData: [{}],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery() {
      switch (this.filters.type) {
        // 租凭
        case 0:
          this.$api.rentalArea.getLeaseContractForProperty().then((res) => {
            if (res.success) {
              this.handleTableData(res.data);
            }
          });
          break;
        // 托管
        case 1:
          this.$api.rentalArea
            .getRentalAreaTrusteeshipContractForProprietor()
            .then((res) => {
              if (res.success) {
                this.handleTableData(res.data);
              }
            });
          break;
      }
    },
    handleTableData(data) {
      // )
      this.tableData = data;
    },
    handleAddOrUpdate() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.handleQuery();
    },
    handleDetail(index, row) {
      this.detailDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.detailDialog.init(row);
      });
    },
    handleTermination() {
      this.$confirm("确认要终止吗？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        cancelButtonClass: "btn-custom-cancel",
        type: "warning",
      }).then(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  margin: 16px;
  padding: 16px;
  width: calc(100% - 32px);
  height: calc(100% - 32px);
  background-color: #fff;
  box-sizing: border-box;
  .page-header {
    width: 100%;
    text-align: left;
    color: #333;
  }
  .pagination-content {
    text-align: right;
  }
}
</style>
